import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import {
  FaUserGraduate,
  FaChalkboardTeacher,
  FaUniversity,
  FaArrowRight,
  FaArrowLeft,
  FaHandshake,
  FaFileAlt,
  FaMicroscope,
  FaGraduationCap,
} from "react-icons/fa";
import { testUrl } from "../BaseData";
import classes from "./GrantlarVaLoyihalar.module.css";
import { getLabels, audiencePath, sectionPath } from "./grantUtils";
import heroImg from "../../../shared/assets/images/grants/grants-banner.jpg";
import memorandumImg from "../../../shared/assets/images/grants/grants-memorandum.jpg";
import grantsImg from "../../../shared/assets/images/grants/grants-grants.jpg";
import researchImg from "../../../shared/assets/images/grants/grants-research.jpg";
import exchangeImg from "../../../shared/assets/images/grants/grants-exchange.jpg";

// Bo'limlar: Talabalarga / O'qituvchilarga / Oliy ta'lim universitetlari uchun
export const AUDIENCE_OPTIONS = [
  { value: "students", label: "students", hint: "studentsHint", Icon: FaUserGraduate },
  { value: "teachers", label: "teachers", hint: "teachersHint", Icon: FaChalkboardTeacher },
  { value: "universities", label: "universities", hint: "universitiesHint", Icon: FaUniversity },
];

// Yuqoridagi rasmli kartochkalar
const SECTIONS = [
  { value: "memorandums", label: "secMemorandums", hint: "secMemorandumsHint", Icon: FaHandshake, img: memorandumImg },
  { value: "grants", label: "secGrants", hint: "secGrantsHint", Icon: FaFileAlt, img: grantsImg },
  { value: "research", label: "secResearch", hint: "secResearchHint", Icon: FaMicroscope, img: researchImg },
  { value: "exchange", label: "secExchange", hint: "secExchangeHint", Icon: FaGraduationCap, img: exchangeImg },
];

/**
 * 1-bosqich: banner, rasmli bo'lim kartochkalari va pastda grant bo'limlari.
 * Grant kartochkasi bosilganda /activity/ilmiy-faoliyat/grantlar-va-loyihalar/<bo'lim> ochiladi
 * (u yerda Xalqaro/Mahalliy filtri va grant kartochkalari).
 */
const GrantlarVaLoyihalar = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const L = getLabels(lang);

  // "Grantlar va loyihalar" bosilganda ?bolim=grantlar — 3 ta grant bo'limi ko'rinadi
  const [searchParams, setSearchParams] = useSearchParams();
  const showGrants = searchParams.get("bolim") === "grantlar";
  const openGrants = () => {
    setSearchParams({ bolim: "grantlar" });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const closeGrants = () => setSearchParams({});

  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${testUrl}/api/grants/`)
      .then((res) => setGrants(Array.isArray(res.data) ? res.data : []))
      .catch(() => setGrants([]))
      .finally(() => setLoading(false));
  }, []);

  // Har bir bo'limdagi grantlar soni ("all" — hammasida hisoblanadi)
  const counts = useMemo(() => {
    const c = {};
    AUDIENCE_OPTIONS.forEach(({ value }) => {
      c[value] = grants.filter((g) => g.audience === value || g.audience === "all").length;
    });
    return c;
  }, [grants]);

  return (
    <div className={classes.page}>
      {showGrants ? (
        <>
          <button type="button" className={classes.back} onClick={closeGrants}>
            <FaArrowLeft /> {L.backToSections}
          </button>
          <h1 className={classes.pageTitle}>{L.secGrants}</h1>

        <div className={classes.audienceTiles}>
          {AUDIENCE_OPTIONS.map(({ value, label, hint, Icon }) => (
            <button
              key={value}
              type="button"
              className={classes.audienceTile}
              onClick={() => navigate(audiencePath(value))}
            >
              <span className={classes.tileIcon}>
                <Icon />
              </span>
              <span className={classes.tileLabel}>{L[label]}</span>
              <span className={classes.tileHint}>{L[hint]}</span>
              <span className={classes.tileFooter}>
                <span className={classes.tileCount}>
                  {loading ? "…" : L.grantCount(counts[value] ?? 0)}
                </span>
                <span className={classes.tileOpen}>
                  {L.open} <FaArrowRight />
                </span>
              </span>
            </button>
          ))}
        </div>
        </>
      ) : (
        <>
        {/* Banner — tayyor rasm (matni rasmning ichida) */}
        <section className={classes.hero}>
          <img src={heroImg} alt="Renessans Grants Projects" className={classes.heroBanner} />
          <h1 className={classes.visuallyHidden}>{L.pageTitle}</h1>
        </section>

        <div className={classes.sectionCards}>
          {SECTIONS.map(({ value, label, hint, Icon, img }) => (
            <div key={value} className={classes.sectionCard}>
              <div className={classes.sectionMedia}>
                <img src={img} alt={L[label]} className={classes.sectionImg} />
                <span className={classes.sectionBadge}>
                  <Icon />
                </span>
              </div>
              <div className={classes.sectionBody}>
                <h3 className={classes.sectionCardTitle}>{L[label]}</h3>
                <p className={classes.sectionCardText}>{L[hint]}</p>
                <button
                  type="button"
                  className={classes.sectionBtn}
                  onClick={value === "grants" ? openGrants : () => navigate(sectionPath(value))}
                >
                  {L.moreInfo} <FaArrowRight />
                </button>
              </div>
            </div>
          ))}
        </div>
        </>
      )}

    </div>
  );
};

export default GrantlarVaLoyihalar;
